<template>
  <div>
    <template v-if="$apollo.loading">
      <loading/>
    </template>

    <template v-else>
      <h2 class="is-size-7 is-uppercase">Artist</h2>
      <h1 id="artist-name" class="title is-size-2 is-size-3-mobile has-text-weight-extra-bold">
        <router-link v-bind:to="{ name: 'artist', params: { id: artist.id } }">
          {{ artist.name }}
        </router-link>
      </h1>

      <template v-if="albums.length">
        <h2 class="is-size-7 is-uppercase">Albums</h2><hr>
        <album-list v-bind:albums="albums" v-bind:showReleaseDate="true">
          <div class="album column is-2-desktop is-3-tablet is-6-mobile">
            <multi-album-cover
              v-bind:albums="this.artist.albums"
              v-on:click="playShuffle"
              class="all-albums-cover poly-cursor-pointer"
            >
              <span class="state-icon icon is-large is-overlay has-text-black poly-hidden poly-visible-touch">
                <i class="mdi mdi-24px mdi-shuffle"></i>
              </span>
            </multi-album-cover>

            <dl style="margin-top:0.4rem;">
              <dd class="album-name has-text-weight-bold poly-truncate">
                All tracks
              </dd>
            </dl>
          </div>
        </album-list>
      </template>

      <template v-if="singles.length">
        <h2 class="is-size-7 is-uppercase">Singles &amp; EPs</h2><hr>
        <album-list v-bind:albums="singles" v-bind:showReleaseDate="true" />
      </template>

      <template v-if="lives.length">
        <h2 class="is-size-7 is-uppercase">Live Albums</h2><hr>
        <album-list v-bind:albums="lives" v-bind:showReleaseDate="true" />
      </template>

      <template v-if="mixes.length">
        <h2 class="is-size-7 is-uppercase">Mixes</h2><hr>
        <album-list v-bind:albums="mixes" v-bind:showReleaseDate="true" />
      </template>

      <template v-if="compilations.length">
        <h2 class="is-size-7 is-uppercase">Compilations</h2><hr>
        <album-list v-bind:albums="compilations" v-bind:showReleaseDate="true" />
      </template>

      <template v-if="artist.features.length">
        <h2 class="is-size-7 is-uppercase">Appears on</h2><hr>
        <album-list v-bind:albums="artist.features" />
      </template>
    </template>
  </div>
</template>

<script>
  import { albumReleaseTypes } from '@/constants'

  import Loading from '@/components/Loading'

  import AlbumList from '@/components/AlbumList'
  import MultiAlbumCover from '@/components/MultiAlbumCover'

  import shuffleArray from '@/mixins/shuffleArray'

  export default {
    name: 'Artist',
    mixins: [shuffleArray],
    components: {
      Loading,
      AlbumList,
      MultiAlbumCover
    },
    computed: {
      albums: function () {
        return this.artist.albums.filter(
          (album) => album.releaseType === albumReleaseTypes.ALBUM
        )
      },
      singles: function () {
        return this.artist.albums.filter(
          (album) => album.releaseType === albumReleaseTypes.SINGLE
        )
      },
      lives: function () {
        return this.artist.albums.filter(
          (album) => album.releaseType === albumReleaseTypes.LIVE
        )
      },
      mixes: function () {
        return this.artist.albums.filter(
          (album) => album.releaseType === albumReleaseTypes.MIX
        )
      },
      compilations: function () {
        return this.artist.albums.filter(
          (album) => album.releaseType === albumReleaseTypes.COMPILATION
        )
      }
    },
    methods: {
      playShuffle: function () {
        this.fetchArtistTracks().then((response) => {
          var shuffledTracksToPlay = this.shuffleArray(response.data.tracks)

          if (this.$store.getters.currentTrack && shuffledTracksToPlay.length > 1) {
            while (shuffledTracksToPlay[0].id === this.$store.getters.currentTrack.id) {
              shuffledTracksToPlay = this.shuffleArray(shuffledTracksToPlay)
            }
          }

          this.$store.commit('playTracks', { tracks: shuffledTracksToPlay })
        }).catch(() => {
          console.error(`There was an error trying to get tracks for artist with id ${this.artist.id}`)
        })
      },
      fetchArtistTracks: function () {
        return this.$apollo.query({
          query: require('@/graphql/RandomArtistTracks.gql'),
          fetchPolicy: 'no-cache',
          variables: { artistId: this.artist.id }
        })
      }
    },
    apollo: {
      artist: {
        query: require('@/graphql/Artist.gql'),
        variables () {
          return {
            id: this.$route.params.id
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .all-albums-cover .state-icon {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100%;
    border: 1px solid $white-ter;
  }
  .all-albums-cover:hover .state-icon { visibility: visible; }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    #artist-name { margin-top: 0.5rem; }

    .album-name { font-size: 0.9rem; }
    .state-icon {
      margin-left: 0.3rem;
      margin-bottom: 0.3rem;
      transform: scale(0.8);
    }
  }
</style>
